var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudentsStudying(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#EDECFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 16.875C20.0003 15.9025 19.614 14.9699 18.9264 14.2823C18.2388 13.5946 17.3061 13.2083 16.3337 13.2083H11.292V26.5H17.2503C17.9797 26.5 18.6791 26.7897 19.1949 27.3055C19.7106 27.8212 20.0003 28.5206 20.0003 29.25M20.0003 16.875V29.25M20.0003 16.875C20.0003 15.9025 20.3866 14.9699 21.0743 14.2823C21.7619 13.5946 22.6945 13.2083 23.667 13.2083H28.7087V26.5H22.7503C22.021 26.5 21.3215 26.7897 20.8058 27.3055C20.2901 27.8212 20.0003 28.5206 20.0003 29.25",
    stroke: "#4A3AFF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentsStudying);
export default __webpack_public_path__ + "static/media/StudentsStudying.2583c110b0efe62500139b6323aafd58.svg";
export { ForwardRef as ReactComponent };